import { createSelector } from "reselect";

import { MeasurementType, type BodyMeasurements } from "@fitness-app/data-models/entities/Measurement";
import { getBodyMeasurementsWithVariation } from "@fitness-app/utils/src/measurements/getBodyMeasurementsWithVariation";

import { type AppStore } from "../../../index";

const getMeasurements = (state: AppStore) => state.traineeMeasurements.measurements;

export const getLatestBodyMeasurements = createSelector([getMeasurements], (measurements) => {
  const bodyMeasurements = measurements.filter(
    (measurement): measurement is BodyMeasurements => measurement.type === MeasurementType.BodyMeasurements,
  );

  return getBodyMeasurementsWithVariation(bodyMeasurements);
});
